export default [
	{  // 反馈管理
		path: 'userfeedback',
		name: 'm_member_userfeedback',
		component: () => import('@/pages/system/userfeedback')
	}, {  // 地址库
		path: 'address_library',
		name: 'm_basicinfo_address_library',
		component: () => import('@/pages/system/address_library')
	}, {  // 单页管理
		path: 'article_list',
		name: 'm_article',
		component: () => import('@/pages/system/article_list')
	}, {  // 字典管理
		path: 'dictionary',
		name: 'm_dictionary',
		component: () => import('@/pages/system/operation_dic_list')
	}, {  // APP版本管理
		path: 'app_version',
		name: 'm_app_version',
		component: () => import('@/pages/system/app_version_list')
	}, {  // APP版本管理 - 新增
		path: 'app_version_add',
		name: 'app_version_add',
		meta: {
			title: '发布APP版本'
		},
		component: () => import('@/pages/system/app_version_add')
	}, {  // APP图标/背景(编辑)
		path: 'app_version_edit/:id',
		name: 'app_version_edit',
		meta: {
			title: '编辑APP版本'
		},
		props: route => route.params,
		component: () => import('@/pages/system/app_version_edit')
	}, {  // UNI-APP版本管理
		path: 'uni_app_version',
		name: 'm_uniapp_version',
		component: () => import('@/pages/system/uniapp_version_list')
	}, {  // UNI-APP - 新增
		path: 'uniapp_version_add',
		name: 'uniapp_version_add',
		meta: {
			title: '发布UNI-APP版本'
		},
		component: () => import('@/pages/system/uniapp_version_add')
	}, {  // UNI-APP(编辑)
		path: 'uniapp_version_edit/:id',
		name: 'uniapp_version_edit',
		meta: {
			title: '编辑UNI-APP版本'
		},
		props: route => route.params,
		component: () => import('@/pages/system/uniapp_version_edit')
	}, {  // 账号列表
		path: 'sys_user_list',
		name: 'm_sysmanage_user',
		component: () => import('@/pages/system/sys_user_list')
	}, {  // 菜单管理
		path: 'menu_manage',
		name: 'm_system_menu',
		component: () => import('@/pages/system/menu_manage')
	}, {  // 表格字段管理
		path: 'field_manage',
		name: 'm_system_menu_field',
		component: () => import('@/pages/system/field_manage')
	}, {  // 角色列表
		path: 'role_list',
		name: 'm_system_role',
		component: () => import('@/pages/system/system_role_list')
	}, {  // 新建角色
		path: 'role_add',
		name: 'role_add',
		meta: {
			title: '新建角色'
		},
		component: () => import('@/pages/system/system_role_add')
	}, {  // 编辑角色
		path: 'role_edit/:id',
		name: 'role_edit',
		meta: {
			title: '编辑角色'
		},
		props: route => route.params,
		component: () => import('@/pages/system/system_role_edit')
	}, {  // 默认验证码
		path: 'system_verify_code',
		name: 'm_system_verify_code',
		component: () => import('@/pages/system/system_verify_code')
	}, {  // 任务中心
		path: 'task_center_list',
		name: 'm_task_center_list',
		component: () => import('@/pages/system/task_center_list')
	}, {  // 售后地址列表
		path: 'after_sale_address',
		name: 'm_after_sale_address',
		component: () => import('@/pages/system/after_sale_address_list')
	}, {  // 发货地址列表
		path: 'delivery_address',
		name: 'm_delivery_address',
		component: () => import('@/pages/system/delivery_address_list')
	}, {  // 新闻列表
		path: 'newsinfo',
		name: 'm_basicinfo_news_info',
		component: () => import('@/pages/system/newsinfo')
	}, {  // 编辑新闻
		path: 'newsinfo_edit/:id',
		name: 'm_newsinfo_edit',
		meta: {
			title: '编辑新闻'
		},
		props: route => route.params,
		component: () => import('@/pages/system/newsinfo_edit')
	}, {  // 新增新闻
		path: 'newsinfo_add',
		name: 'm_newsinfo_add',
		meta: {
			title: '添加新闻'
		},
		component: () => import('@/pages/system/newsinfo_add')
	}, {  // 系统配置
		path: 'platform_config',
		name: 'm_platform_config',
		component: () => import('@/pages/system/platform_config')
	}, {  // 商城配置
		path: 'mall_config',
		name: 'm_mall_config',
		component: () => import('@/pages/system/mall_config')
	}, {  // 操作日志
		path: 'sys_user_log',
		name: 'm_sys_user_log',
		component: () => import('@/pages/system/sys_user_log_list')
	}, {  // 缓存列表
		path: 'cache_list',
		name: 'm_cache_info',
		component: () => import('@/pages/system/cache_list')
	}, {  // MQ错误日志
		path: 'mq_error_log',
		name: 'm_mq_error_log',
		component: () => import('@/pages/system/mq_error_log_list')
	}, {  //违禁词管理
		path: 'prohibited/words',
		name: 'm_prohibited_words',
		component: () => import('@/pages/system/prohibited_words_list')
	}
];